import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  documentType: [],
  allDocumentType: []
};

export const DocumentTypesSlice = createSlice({
  name: "documentTypes",
  initialState,
  reducers: {
    getDocumentTypesAction: (state, action) => {
      state.allDocumentType = action.payload;
    },
    getDocumentTypeAction: (state, action) => {
      state.documentType = action.payload;
    },
  },
});

export default DocumentTypesSlice.reducer;

export const { getDocumentTypesAction, getDocumentTypeAction } = DocumentTypesSlice.actions;
